module.exports = __webpack_public_path__ + "static/media/virtual_sports.bf651617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/virtual_sports.jpg
// module id = 2410
// module chunks = 7